import React from 'react'
import './Dashboard.scss'
import { Statistics } from '../../../Components'

const Dashboard = () => {
  return (
    <div className='dashboard mb-4'>
      <div className='container'>
        <Statistics></Statistics>
      </div>
    </div>
  )
}

export default Dashboard
